

import React, { useState } from "react";
import { Tabs, Tab, Form, Row, Col } from "react-bootstrap";
import { formatDate } from "../utils/date";

export default function UpcomingList({ mobile, events, today, onSelectEvent, getEventColor, branchOfficesData }) {
  const [activeTab, setActiveTab] = useState("enCurso");
  const [searchEnCurso, setSearchEnCurso] = useState("");
  const [searchTodos, setSearchTodos] = useState("");

  // Normaliza fechas a solo día para comparar eventos de "hoy"
  const isToday = (date) => {
    const d = new Date(date);
    const t = new Date(today);
    return d.getFullYear() === t.getFullYear() && d.getMonth() === t.getMonth() && d.getDate() === t.getDate();
  };


  // Filtro de búsqueda solo por nombre
  const filterEvents = (arr, search) =>
    arr.filter(
      (ev) =>
        !search ||
        ev.name?.toLowerCase().includes(search.toLowerCase())
    );

  const filterEvents2 = (arr, search) => {
    let filterNow = arr.filter(item  => search === item.name.toLowerCase() );
    console.log(filterNow);

    return search === "" ? arr : filterNow;
  }

  // Eventos en curso (hoy)
  const eventosHoy = filterEvents(
    events.filter((e) => isToday(e.start) || isToday(e.end) || (e.start <= today && e.end >= today)),
    searchEnCurso
  );

  // Todos los eventos
  const todosEventos = filterEvents2(events, searchTodos);

  // Renderiza lista de eventos
  const renderList = (arr) => (
    <div className="ec-upcoming">
      {arr.length === 0 && <div className="text-center text-muted py-4">No hay eventos</div>}
      {arr.map((ev) => {
        const mc = getEventColor(ev);
        const branchNames = (ev.branches || [])
          .map((bId) => branchOfficesData.find((b) => b.id === bId)?.name)
          .filter(Boolean);
        return (
          <button key={ev.id} onClick={() => { onSelectEvent(ev); }} className="ec-upcoming-card">
            <div className="ec-upcoming-bar" style={{ background: mc }} />
            <div className="ec-upcoming-info">
              <div className="ec-upcoming-title">{ev.name}</div>
              <div className="ec-upcoming-dates">{formatDate(ev.start)} → {formatDate(ev.end)}</div>
              <div className="ec-upcoming-machines">
                {branchNames.slice(0, mobile ? 1 : 2).map((n) => (
                  <span key={n} className="ec-machine-badge" style={{ background: "#6366F114", color: "#6366F1" }}>{n}</span>
                ))}
                {branchNames.length > (mobile ? 1 : 2) && (
                  <span style={{ fontSize: 9, color: "#94a3b8" }}>+{branchNames.length - (mobile ? 1 : 2)}</span>
                )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="mt-5">
      <Tabs
        id="event-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3 justify-content-center"
      >
        <Tab eventKey="enCurso" title="En curso">
          <Row className="justify-content-center mb-3">

            
            <Col xs={12} md={8} lg={6} className="d-flex justify-content-center align-items-center">
            <i class="uil uil-search m-2"></i>
              <Form.Control
                type="text"
                placeholder="Buscar eventos en curso..."
                value={searchEnCurso}
                onChange={(e) => setSearchEnCurso(e.target.value)}
                className="text-center"
                style={{ maxWidth: 400 }}
              />
            </Col>
          </Row>
          {renderList(eventosHoy)}
        </Tab>
        <Tab eventKey="todos" title="Todos los eventos">
          <Row className="justify-content-center mb-3">
            <Col xs={12} md={8} lg={6} className="d-flex justify-content-center align-items-center">
            <i class="uil uil-search m-2"></i>
              <Form.Control
                type="text"
                placeholder="Buscar en todos los eventos..."
                value={searchTodos}
                onChange={(e) => setSearchTodos(e.target.value)}
                className="text-center"
                style={{ maxWidth: 400 }}
              />
            </Col>
          </Row>
          {renderList(todosEventos)}
        </Tab>
      </Tabs>
    </div>
  );
}
